import { useSelector } from "react-redux";
import Bill from "./components/Bill";
import CartItem from "./components/CartItem";

export default function Cart() {
  const cartItems = useSelector((state) => state.cart);

  return (
    <>
      <div className="container 2xl:px-8 px-2 mx-auto">
        <h2 className="mb-8 text-xl font-bold">Shopping Cart</h2>
        <div className="cartListContainer">
          <div className="space-y-6">
            {/* Cart Item */}
            {cartItems.length ? (
              cartItems.map((item) => <CartItem key={item.id} item={item} />)
            ) : (
              <h1>No Items in Cart</h1>
            )}
            {/* Cart Items Ends */}
          </div>
          {/* Bill Details */}
          <Bill />
        </div>
      </div>
    </>
  );
}
